import { EntityState } from '@ngrx/entity';

export interface IpFiltering {
  id: number;
  clientInfoId: number;
  clientName?: string;
  ipFilterName: string;
  ipFilterStart: string;
  ipFilterEnd: string;
  isActive: boolean;
  isDeleted?: boolean;
}

export interface IpFilteringState extends EntityState<IpFiltering> {
  selectedIpFilteringId: number | null;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export enum IpFilteringEditErrorMessage {
  CORPORATION_REQUIRED = 'Corporation is required',
  IP_FILTER_END_REQUIRED = 'Filter To is required',
  IP_FILTER_TYPE = 'Please enter a valid IP address',
  IP_FILTER_START_REQUIRED = 'Filter From is required',
  IP_FILTER_START_IP_FILTER_TO_COMPARASION = 'Filter from should be less than Filter to',
  IP_FILTER_TO_IP_FILTER_START_COMPARASION = 'Filter to should be more than Filter from',
}
